import { arrow1, arrow2 } from '../../../../common/back/lace/arrow'
import { verticalKnot, webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const wp5Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 模様 'W'
  ctx.beginPath()
  ctx.moveTo(581, 112)
  ctx.quadraticCurveTo(522, 205, 522, 205)
  ctx.quadraticCurveTo(592, 217, 592, 217)
  ctx.quadraticCurveTo(543, 321, 543, 321)
  ctx.quadraticCurveTo(561, 316, 618, 333)
  ctx.quadraticCurveTo(633, 323, 633, 323)
  ctx.quadraticCurveTo(585, 283, 585, 283)
  ctx.quadraticCurveTo(639, 194, 639, 194) // 中央上
  ctx.quadraticCurveTo(573, 184, 573, 184)
  ctx.quadraticCurveTo(614, 141, 614, 141)
  ctx.quadraticCurveTo(598, 116, 581, 112)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // 模様 'レース左下'
  ctx.beginPath()
  ctx.moveTo(498, 283) // 左下
  ctx.quadraticCurveTo(527, 254, 575, 236) // 右上
  ctx.stroke()
  ctx.closePath()

  // // 模様 'レース右上'
  ctx.beginPath()
  ctx.moveTo(660, 301) // 右上
  ctx.quadraticCurveTo(627, 280, 606, 283) // 左下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //

  // 模様 Wの左上
  ctx.moveTo(578, 110) // 左上
  ctx.quadraticCurveTo(518, 208, 518, 208) // 左下
  ctx.quadraticCurveTo(587, 220, 587, 220) // 中央下
  ctx.quadraticCurveTo(538, 324, 538, 324) //
  ctx.quadraticCurveTo(561, 318, 615, 336) //
  ctx.quadraticCurveTo(636, 321, 636, 321) //
  ctx.quadraticCurveTo(590, 282, 590, 282) //
  ctx.quadraticCurveTo(643, 191, 643, 191) //
  ctx.quadraticCurveTo(581, 182, 581, 182) //
  ctx.quadraticCurveTo(618, 141, 618, 141) //
  ctx.quadraticCurveTo(598, 115, 578, 110) //

  // 模様 'レース左下'
  ctx.moveTo(497, 280) // 左下＿左下
  ctx.quadraticCurveTo(529, 248, 578, 233) // 左下_右上
  ctx.quadraticCurveTo(580, 237, 580, 237) // 左下_右下
  ctx.quadraticCurveTo(514, 266, 500, 287) // 左下_左下

  // 模様 'レース左下'
  ctx.moveTo(663, 300) // 右上_右上
  ctx.quadraticCurveTo(628, 277, 600, 280) // 右上_左上
  ctx.quadraticCurveTo(599, 284, 599, 285) // 右上_左下
  ctx.quadraticCurveTo(627, 284, 660, 305) // 右上_左上

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -130, 60, 1) // ウェブ先端寄りのウェブ結び目
  verticalKnot(ctx, laceColor, 585, -270, 15, 1) //
  arrow1(ctx, laceColor, 0, 0, 0, 1)
  arrow1(ctx, laceColor, -15, 10, 0, 1)
  arrow1(ctx, laceColor, -30, 20, 0, 1)
  arrow1(ctx, laceColor, -45, 30, 0, 1)
  arrow2(ctx, laceColor, 0, 0, 0, 1)
  arrow2(ctx, laceColor, -15, -6, 0, 1)
  arrow2(ctx, laceColor, -32, -11, 0, 1)
}
